<template>
  <footer
    class="bg-brand-darkblue-navy text-white theme-transition border-t border-status-info"
  >
    <div class="container mx-auto px-4 pt-10 pb-6">
      <div
        class="flex flex-col min-md:flex-row items-start justify-between gap-8"
      >
        <!-- Brand Logo and Name -->
        <router-link
          class="!duration-0 flex items-center lg:mb-0 text-white hover:text-brand-yellow focus:text-brand-yellow focus-visible:text-brand-yellowtransition-colors lg:mx-auto min-lg:my-auto"
          to="/"
          :aria-label="$t('header.goToHomepage')"
        >
          <img
            v-once
            src="/images/biglo_logo.png"
            :alt="$t('header.bigloLogo')"
            width="40"
            height="40"
            loading="lazy"
          />
          <div v-once class="text-4xl font-medium ml-2">Biglo</div>
        </router-link>

        <!-- Footer Links -->
        <div
          class="grid grid-cols-1 min-sm:grid-cols-2 min-md:grid-cols-4 gap-8 w-full max-w-4xl text-center"
        >
          <!-- About Us Section -->
          <section :aria-labelledby="'about-us-heading'">
            <h2
              :id="'about-us-heading'"
              class="text-lg text-brand-yellow-light font-medium mb-4"
            >
              {{ $t("common.nav.aboutUs") }}
            </h2>
            <ul class="space-y-2">
              <li>
                <router-link
                  to="/our-mission"
                  class="hover:text-brand-yellow focus:text-brand-yellow focus-visible:text-brand-yellowtransition-colors"
                >
                  {{ $t("common.nav.ourMission") }}
                </router-link>
              </li>
              <li>
                <router-link
                  to="#"
                  aria-disabled="true"
                  class="text-[#c7c7c7] cursor-not-allowed transition-colors"
                >
                  {{ $t("footer.ourPartners") }}
                </router-link>
              </li>
            </ul>
          </section>

          <!-- Resources Section -->
          <section :aria-labelledby="'resources-heading'">
            <h2
              :id="'resources-heading'"
              class="text-lg text-brand-yellow-light font-medium mb-4"
            >
              {{ $t("footer.resources") }}
            </h2>
            <ul class="space-y-2">
              <li>
                <router-link
                  to="#"
                  @click.prevent
                  aria-disabled="true"
                  class="text-[#c7c7c7] cursor-not-allowed transition-colors"
                >
                  {{ $t("common.nav.faq") }}
                </router-link>
              </li>
              <li>
                <router-link
                  to="/blog"
                  class="hover:text-brand-yellow focus:text-brand-yellow focus-visible:text-brand-yellowtransition-colors"
                >
                  {{ $t("common.nav.blog") }}
                </router-link>
              </li>
            </ul>
          </section>

          <!-- Legal Section -->
          <section :aria-labelledby="'legal-heading'">
            <h2
              :id="'legal-heading'"
              class="text-lg text-brand-yellow-light font-medium mb-4"
            >
              Legal
            </h2>
            <ul class="space-y-2">
              <li>
                <router-link
                  to="#"
                  @click.prevent
                  aria-disabled="true"
                  class="text-[#c7c7c7] cursor-not-allowed transition-colors"
                >
                  {{ $t("common.nav.termsConditions") }}
                </router-link>
              </li>
              <li>
                <router-link
                  to="#"
                  @click.prevent
                  aria-disabled="true"
                  class="text-[#c7c7c7] cursor-not-allowed transition-colors"
                >
                  {{ $t("common.nav.privacyPolicy") }}
                </router-link>
              </li>
              <li>
                <router-link
                  to="#"
                  @click.prevent
                  aria-disabled="true"
                  class="text-[#c7c7c7] cursor-not-allowed transition-colors"
                >
                  {{ $t("common.nav.cookiesPolicy") }}
                </router-link>
              </li>
            </ul>
          </section>

          <!-- Social Links -->
          <section :aria-labelledby="'social-heading'">
            <h2
              :id="'social-heading'"
              class="text-lg text-brand-yellow-light font-medium mb-4"
            >
              {{ $t("common.social.followUs") }}
            </h2>
            <div class="flex flex-col space-y-2 items-center">
              <!-- LinkedIn -->
              <a
                href="https://www.linkedin.com/company/biglosolutions/"
                target="_blank"
                rel="noopener noreferrer"
                class="text-white hover:text-brand-yellow focus:text-brand-yellow focus-visible:text-brand-yellow!transition-none !duration-0"
                :aria-label="$t('common.social.linkedIn')"
              >
                <svg class="w-6 h-6 fill-current !transition-none !duration-0">
                  <use xlink:href="/images/sprite.svg#linkedin-icon" />
                </svg>
              </a>

              <!-- YouTube -->
              <a
                href="https://www.youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                class="text-white hover:text-brand-yellow focus:text-brand-yellow focus-visible:text-brand-yellow!transition-none !duration-0"
                :aria-label="$t('common.social.youtube')"
              >
                <svg class="w-6 h-6 fill-current !transition-none !duration-0">
                  <use xlink:href="/images/sprite.svg#youtube-icon" />
                </svg>
              </a>
            </div>
          </section>
        </div>
      </div>

      <!-- Divider -->
      <div class="border-t border-status-info mb-6 mt-12"></div>

      <!-- Copyright -->
      <div class="text-center text-sm text-white">
        {{
          $t("common.company.copyright", {
            year: new Date().getFullYear(),
            company: $t("common.company.name"),
          })
        }}
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>

<style scoped></style>
